'use client'

import { useRouter } from 'next/router'
import React, { useContext } from 'react'
import { AppContext } from './applicationContext'

const HEIGH_COMPONENT = ({ Component, pageProps }: any) => {
  const router = useRouter()
  const contextValue: any = useContext(AppContext)
  return <Component {...pageProps} {...contextValue} router={router} />
}

export default HEIGH_COMPONENT
